import React from "react";
import { useTranslation } from "react-i18next";
import { getOrderTypeKey, isPickupOrder } from "../../utils/orderCustomerDisplay";
import "./orderCustomerDisplay.css";

/**
 * Delivery / Pickup pill matching Figma fulfilment badges.
 */
export default function OrderTypeBadge({ order, userGetMode, className = "" }) {
  const { t } = useTranslation("translation");
  const modeSource = order || { userGetMode };
  const pickup = isPickupOrder(modeSource);
  const label = t(getOrderTypeKey(modeSource), pickup ? "Pickup" : "Delivery");

  return (
    <span
      className={`oh-order-type-badge ${
        pickup ? "oh-order-type-badge--pickup" : "oh-order-type-badge--delivery"
      } ${className}`.trim()}
    >
      {label}
    </span>
  );
}
